import React, {useEffect, useState} from 'react';
import styled from "styled-components";

import AccountQuery from '../../gql/Account';
import {useMutation, useQuery} from "@apollo/client";
import Spinner from "../Spinner";
import {Button, Buttons, Form, Input} from "../form";
import AdminUpdateAccountMutation from "../../gql/AdminUpdateAccount";
import Overlay from "../Overlay";

interface EditAccountProps {
    accountId: any,
    close: () => void
}

const EditAccount:React.FC<EditAccountProps> = ({accountId, close}) => {
    const {data, loading} = useQuery(AccountQuery, {
        variables: {
            id: accountId||''
        }
    });
    const [updateAccount] = useMutation(AdminUpdateAccountMutation)

    const [firstName, setFirstName] = useState<string>();
    const [lastName, setLastName] = useState<string>();
    const [email, setEmail] = useState<string>();
    const [phone, setPhone] = useState<string>();
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const account = data?.accountById;
        if (!account)
            return;

        setFirstName(account.firstName);
        setLastName(account.lastName);

        const email = account.contacts?.nodes?.find((contact:any) => contact.type === 'email')?.value.address;
        if (email)
            setEmail(email);

        const phone = account.contacts?.nodes?.find((contact:any) => contact.type === 'phone')?.value.number;
        if (phone)
            setPhone(phone);
    }, [data, setFirstName, setLastName, setEmail, setPhone]);

    // const [details, setDetails] = useState<any>();

    const closeHandler = (e?:any) => {
        if (typeof e?.preventDefault === 'function') e.preventDefault();

        if (e.target === e.currentTarget)
            close();
    }

    const saveHandler = (e?:any) => {
        if (typeof e?.preventDefault === 'function') e.preventDefault();

        const data: any = {
            firstName,
            lastName,
            email,
            phone
        };

        if (password)
            data.password = password;

        setSaving(true);

        updateAccount({
            variables: {
                input: {
                    accountId,
                    data
                }
            }
        })
            .then(close);
    }

    const changeHandler = (data:any) => {
        const {name, value} = data.target;

        switch (name) {
            case 'firstName':
                setFirstName(value);
                break;
            case 'lastName':
                setLastName(value);
                break;
            case 'email':
                setEmail(value);
                break;
            case 'phone':
                setPhone(value);
                break;
            case 'password':
                setPassword(value.trim());
                break;
            case 'confirmPassword':
                setConfirmPassword(value.trim());
                break;
        }
    }

    const invalidPassword = password !== confirmPassword;

    return (
        <Overlay>
            <Popup>{loading ? <Loading/> : (
                <StyledForm>
                    <h2>Edit Account</h2>
                    <Input label="First Name" value={firstName} name="firstName" onChange={changeHandler}/>
                    <Input label="Last Name" value={lastName} name="lastName" onChange={changeHandler}/>
                    <Input label="Email Address" value={email} name="email" type="email" onChange={changeHandler}/>
                    <Input label="Phone Number" value={phone} name="phone" type="tel" onChange={changeHandler}/>
                    <Input label="New Password" value={password} name="password" onChange={changeHandler} className={invalidPassword ? 'invalid' : ''}/>
                    <Input label="Confirm Password" value={confirmPassword} name="confirmPassword" onChange={changeHandler} className={invalidPassword ? 'invalid' : ''}/>
                    <Buttons>
                        <Button onClick={closeHandler} variation="transparent" disabled={saving}>Cancel</Button>
                        <Button onClick={saveHandler} disabled={saving || invalidPassword}>{saving ? 'Saving...' : 'Save'}</Button>
                    </Buttons>
                </StyledForm>
            )}</Popup>
        </Overlay>
    )
};

export default EditAccount;

const StyledForm = styled(Form)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: .5rem;
    
    h2 {
        margin-top: 0;
    }
    
    h2, ${Buttons} {
        grid-column: span 2;
    }
`;

const Popup = styled.div`
    background: #fff;
    padding: 1rem;
`;

const Loading = styled.div.attrs({children:<Spinner/>})`
    padding: 2rem;
`;